import { render, staticRenderFns } from "./SendScreenRecording.vue?vue&type=template&id=31ce692c&scoped=true"
import script from "./SendScreenRecording.vue?vue&type=script&lang=js"
export * from "./SendScreenRecording.vue?vue&type=script&lang=js"
import style0 from "./SendScreenRecording.vue?vue&type=style&index=0&id=31ce692c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ce692c",
  null
  
)

export default component.exports